import React from "react";
import ReactTooltip from "react-tooltip";
import "react-datepicker/dist/react-datepicker.css";
import Translate from "helpers/Translate";

// Styles
import "../../FileHistory/Filters/Filters.styles.scss";

function SearchFilters({
  handleFilterData,
  handleResetFilter,
  selectedOriginalFilename,
  setSelectedOriginalFilename
}) {
  return (
    <>
      <ReactTooltip />
      <div className="file-deleted__filters-bar">
        <div className="search file-deleted__search">
          <div className="search-inputs">
            <div className="searchIcon">
              <i className="fa fa-search" aria-hidden="true"></i>
            </div>
            <input
              type="text"
              data-tip={Translate({ id: "original_filename" })}
              className="form-input"
              placeholder={Translate({ id: "original_filename" })}
              value={selectedOriginalFilename}
              onChange={e => setSelectedOriginalFilename(e.target.value.trim())}
            />
          </div>
        </div>
        <div className="file-deleted__filters-actions">
          <button
            data-test="btnadd"
            className="btn btn-info"
            onClick={handleFilterData}
          >
            <i className="fas fa-filter mr-10"></i>
            {Translate({ id: "filter" })}
          </button>
          <button
            data-test="btnadd"
            className="btn btn-danger"
            onClick={handleResetFilter}
          >
            <i className="fas fa-redo mr-10"></i>
            {Translate({ id: "reset_filter" })}
          </button>
        </div>
      </div>
    </>
  );
}
export default SearchFilters;
